export function findByKeyValue(array: Array<any>, key: string, value: any): any {
  const filter = array.filter((item) => item[key] === value);

  return filter.length ? filter[0] : null;
}

export function indexOfKeyValue(array: Array<any>, key: string, value: any): any {
  return array.reduce((result, item, i) => {
    return result === -1 && item[key] === value ? i : result;
  }, -1);
}
